
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[boardId]",
      function () {
        return require("private-next-pages/[boardId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[boardId]"])
      });
    }
  